import { ContextService } from '../../services/context_service';
import { Md5 } from 'ts-md5/dist/md5';

const mapContextKey = 'MapLocationHash';

export function setRoutingToLocationHash(routing: any, contextService: ContextService) {
    let hashMap: any = {};
    if (!contextService.get(mapContextKey)) {
        contextService.set(mapContextKey, hashMap);
    } else {
        hashMap = contextService.get(mapContextKey);
    }
    const mapKey = Md5.hashAsciiStr(JSON.stringify(routing)).toString();
    hashMap[mapKey] = routing;
    contextService.set(mapContextKey, hashMap);
    // console.log('LocationHash', hashMap);
    window.location.hash = mapKey;
}

export function getRoutingFromLocationHash(locationHash: string, contextService: ContextService) {
    let hashMap: any = {};
    if (!contextService.get(mapContextKey)) {
        contextService.set(mapContextKey, hashMap);
    } else {
        hashMap = contextService.get(mapContextKey);
    }
    const mapKey = locationHash.substring(1); // entferne #
    return hashMap[mapKey];
}

